export { default as Img200 } from './processed/200/Front-Runner-The.jpg';
export { default as Img400 } from './processed/400/Front-Runner-The.jpg';
export { default as Imgthumb } from './processed/thumb/Front-Runner-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Front-Runner-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Front-Runner-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      118,
      76,
      51
    ],
    "_population": 954,
    "_hsl": [
      0.06218905472636815,
      0.3964497041420118,
      0.3313725490196079
    ]
  },
  "LightVibrant": {
    "_rgb": [
      199,
      158,
      133
    ],
    "_population": 794,
    "_hsl": [
      0.06313131313131314,
      0.3707865168539325,
      0.6509803921568628
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      9,
      24,
      68
    ],
    "_population": 446,
    "_hsl": [
      0.6242937853107344,
      0.7662337662337663,
      0.15098039215686274
    ]
  },
  "Muted": {
    "_rgb": [
      88,
      110,
      165
    ],
    "_population": 1381,
    "_hsl": [
      0.6190476190476191,
      0.30434782608695654,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      190,
      200
    ],
    "_population": 203,
    "_hsl": [
      0.5595238095238095,
      0.20289855072463756,
      0.7294117647058824
    ]
  },
  "DarkMuted": {
    "_rgb": [
      84,
      53,
      37
    ],
    "_population": 1717,
    "_hsl": [
      0.056737588652482275,
      0.3884297520661157,
      0.2372549019607843
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Front-Runner-The.js